import { useContext, useEffect, useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { AppContext, Signin } from './context/app-context';
import { Error } from './components';
import { AppRoutes } from './features';
import { loginRequest } from './auth/authConfig';
import { httpGet } from './common/api';
import { Profile } from './models/profile-interface';
import { Country, CountryContent } from './models/countries-interface';
import { api } from './utils/api';

import "./fontawesome";
import './App.scss';

function App() {
  const { error, isAuthenticated } = Signin();
  const { instance } = useMsal();

  const [attemptLoad, setAttemptLoad] = useState(false);
  const [loadingProfile, setLoadingProfile] = useState(false);
  const [loadingCountries] = useState(false);
  const [profileError] = useState(false);
  const { profile, setProfile, countries, setCountries, setSelectedCountry, token, setToken, isLoadingCountry: loading, setLoadingCountry: setLoading } = useContext(AppContext);

  useEffect(() => {
    if (isAuthenticated && attemptLoad === false) {
	  const account = instance.getAllAccounts()[0];
	  setLoadingProfile(false);
	  setAttemptLoad(true);
	  instance.acquireTokenSilent({
	    ...loginRequest,
		account: account,
	  })
	    .then((msalResponse) => {
	      api.setApiToken(msalResponse.accessToken);
		  if (!token) {
		    setToken(msalResponse.accessToken);
		  }
		  if (!profile) {
		    setLoading(true);
		    httpGet('Auth/CurrentUser', msalResponse.accessToken)
			  .then((p: any) => {
				const workingProfile: Profile = {
				  UserId: p.id,
				  FirstName: p.firstName,
				  LastName: p.lastName,
				  EmailAddress: p.emailAddress,
				  Theme: '',
				  Rights: p.rights,
				  Market: p.market,
				  ExportServicesEnabled: p.exportServicesEnabled,
				  TagsManagementEnabled: p.tagsManagementEnabled,
				};
				setProfile(workingProfile);

				setLoadingProfile(false);

				if (!countries) {
			      httpGet(`Content/Countries${p.market === "All" ? "" : `?country=${p.market}`}`, msalResponse.accessToken)
				    .then((result: CountryContent[]) => {
					  const countries: Country[] = result.map(x => {
						return {
						  id: x.id,
						  ...x.data,
						};
					  })
					  // exclude markets that cannot be managed by the portal (redirects or unreleased)
					  .filter((x) => x.code.iv !== "GH" && x.code.iv !== "IN" && x.code.iv !== "TR" && x.code.iv !== "NZ");

					  setCountries(countries);
					  if (p.market === "All") {
		     		    setSelectedCountry(countries[0]);
				      } else {
					    setSelectedCountry(countries.find((c: any) => c.code && c.code.iv === p.market));
					  }
					  setLoading(false);
			        });
				}
			  })
		      .catch((error) => {
		        console.log(error);
		      });
		  }		
		})
		.catch((error) => {
	      instance.acquireTokenRedirect(loginRequest)
		    .then((redirectResponse) => {
			  console.log(redirectResponse);
			});
		});
	}

	if (loadingProfile || loadingCountries) {
	  setLoading(true);
	} else {
	  setLoading(false);
	}
  }, [isAuthenticated, attemptLoad, setProfile, setCountries, token, loadingProfile, loadingCountries, instance, profile, setToken, setLoading, countries, setSelectedCountry]);

  return (
	<>
	  {(isAuthenticated === false) && (
        <>
		  {"Loading..."}
		</>
      )}
	  {isAuthenticated && !loading && !(error || profileError) &&
	    <>
		  <AppRoutes />
		</>
	  }
	  {(error || profileError) && <Error />}
	</>
  );
}

export default App;
